/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import Wallet from './component/wallet'
import { Spin } from 'antd'

class ClubWallet extends React.Component {
  static defaultProps = {
    clubWalletList: {
      list: [],
    },
    walletType: [],
    selectWallet: [],
  }
  state = {
    loading: true,
  }

  componentDidMount() {
    this.props.fetchClubWalletList().then((res) => {
      this.setState({ loading: false })
    })
  }

  render() {
    const { clubWalletList, walletType, selectWallet } = this.props
    return (
      <div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Wallet
            clubWalletList={clubWalletList}
            walletType={walletType}
            selectWallet={selectWallet}
            fetchDelWallet={this.props.fetchDelWallet}
            fetchAddClubWallet={this.props.fetchAddClubWallet}
            fetchUpdateClubWallet={this.props.fetchUpdateClubWallet}
            fetchClubWalletType={this.props.fetchClubWalletType}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    clubWalletList: state.getClubWallet.clubWalletList,
    walletType: state.getClubWallet.walletType,
    selectWallet: state.getClubWallet.selectWallet,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubWallet))



// WEBPACK FOOTER //
// ./src/containers/ClubWallet/index.js